var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[(_vm.user)?_c('vHeader'):_vm._e(),_c('vbase')],1)}
var staticRenderFns = []

export { render, staticRenderFns }